const PARTS = [
  ["1–3", "What We Inherited", "The Child at the Centre / Beyond Bloodlines / The Family Ladder", "text-marigold"],
  ["4–6", "What We Built", "How We Became Us / There Is No One Right Shape / Your Child Is My Child", "text-marigold"],
  ["7–10", "What Living Together Reveals", "Mine Yours and Ours / You Bring Yourself With You / Belonging Without Competition / Community Does Not Cancel Power", "text-marigold"],
  ["11–12", "Making Family Possible", "Building Close Without One Big House / The Structure Changes", "text-rose"],
];

export const Contents = () => (
  <section id="contents" className="bg-ink text-sand py-24 md:py-32" data-testid="contents-section">
    <div className="max-w-6xl mx-auto px-6">
      <h2 className="font-mono font-bold fr-h2 fr-reveal">Contents</h2>
      <div className="mt-12 grid sm:grid-cols-2 md:grid-cols-4 gap-px bg-marigold/40">
        {PARTS.map(([n, title, ch, color], i) => (
          <div key={title} className="fr-reveal bg-ink p-6 transition-colors duration-300 hover:bg-[#2a2010]" style={{ transitionDelay: `${i * 80}ms` }} data-testid={`contents-part-${i + 1}`}>
            <p className={`font-mono fr-big whitespace-nowrap ${color}`}>{n}</p>
            <p className="font-mono fr-lbl mt-6 text-sand/70">Part {["One", "Two", "Three", "Four"][i]}</p>
            <p className="font-mono font-bold mt-2">{title}</p>
            <p className="mt-2 text-sm leading-[1.6]">{ch}</p>
          </div>
        ))}
      </div>
      <p className="font-mono fr-lbl mt-8">+ Introduction: What If We Raised Our Kids Together / Closing: The Commitment Remains</p>
    </div>
  </section>
);
